import { BehaviorSubject, Observable } from 'rxjs';
import { Country, UserModel } from '../../../models';

export abstract class IUserService {
  abstract userCountries$: BehaviorSubject<Country[]>;
  abstract me(): Observable<UserModel>;
  abstract isDummyUserActive(): boolean;
  abstract refreshUserData(): Promise<UserModel>;
}
